import { SWReactIcons } from "@similarweb/icons";
import { numberFilter } from "app/filters/ngFilters";
import type { ITableHeaderCellProps } from "../interfaces/ITableCellProps";
import styled from "styled-components";
import { PlainTooltip } from "app/components/React/Tooltip/PlainTooltip/PlainTooltip";
import { NewLabel } from "pro-features/components/NewLabel/NewLabel";
import { i18nFilter } from "app/filters/i18nFilter";
import type { IconName } from "@similarweb/icons";
import { Bullet } from "pro-features/styled components/StyledLabel/Bullet";
import { Badge } from "@similarweb/ui-components";

export interface IDefaultCellHeaderProps extends ITableHeaderCellProps {
    headerCellTextCls: string;
    isBeta: boolean;
    isNew?: boolean;
    totalCountFormatter?(totalCount: number): string;
    iconName?: IconName;
    bulletColor?: string;
}

const LabelWrapper = styled.span`
    display: flex;

    > div {
        height: 16px;
    }
`;

const IconContainer = styled.div`
    display: flex;
    align-items: center;
    padding-left: 4px;
`;

const BulletContainer = styled.div`
    display: flex;
    padding-right: 4px;
`;

export const SortComponent = (props: { sortDirection: string }) => {
    const { sortDirection } = props;
    return (
        <div className="headerCell-sortDirection">
            {sortDirection.toUpperCase() === "DESC" ? (
                <SWReactIcons
                    iconName="arrow-down-grey"
                    size="xs"
                />
            ) : null}
            {sortDirection.toUpperCase() === "ASC" ? (
                <SWReactIcons
                    iconName="arrow-up-grey"
                    size="xs"
                />
            ) : null}
        </div>
    );
};

export const DefaultCellHeader = (props: IDefaultCellHeaderProps) => {
    const {
        className = "",
        sortDirection,
        tableMetadata,
        showTotalCount,
        sortable,
        headerCellTextCls,
        displayName = i18nFilter()(props.field),
        displayTooltip,
        isBeta,
        isNew,
        totalCountFormatter = numberFilter(),
        iconName,
        bulletColor,
    } = props;
    return (
        <div
            className={`u-relative ${className}`}
            data-automation="header-cell"
        >
            <div className="u-flex-row">
                {bulletColor ? (
                    <BulletContainer>
                        <Bullet color={bulletColor} />
                    </BulletContainer>
                ) : null}
                <PlainTooltip
                    text={displayTooltip}
                    enabled={!!displayTooltip}
                >
                    <span
                        data-automation="header-cell.text"
                        className={headerCellTextCls || "headerCell-text u-truncate"}
                    >
                        {displayName}
                    </span>
                </PlainTooltip>
                {showTotalCount ? (
                    <div className="headerCell-totalCount">
                        {tableMetadata.totalCount < 0
                            ? "..."
                            : `(${totalCountFormatter(tableMetadata.totalCount)})`}{" "}
                    </div>
                ) : null}
                {isBeta ? (
                    <LabelWrapper>
                        <Badge type="beta" />
                    </LabelWrapper>
                ) : null}
                {isNew ? (
                    <LabelWrapper>
                        <NewLabel />
                    </LabelWrapper>
                ) : null}
                {iconName ? (
                    <IconContainer className="headerCell-icon">
                        <SWReactIcons
                            iconName={iconName}
                            size="xs"
                        />
                    </IconContainer>
                ) : null}
                {sortable ? <SortComponent sortDirection={sortDirection} /> : null}
            </div>
        </div>
    );
};
DefaultCellHeader.displayName = "DefaultCellHeader";
